import React, { useId } from 'react';

/*
 * Marque du portail. En SVG plutôt qu'en image pour rester net à toute taille,
 * et en composant pour n'exister qu'une fois : l'ancien « ⬡ » était recopié en
 * dur dans trois écrans, sous forme d'un glyphe que beaucoup de systèmes ne
 * possèdent pas — c'est d'ailleurs ce qui rendait l'ancien favicon vide.
 */
export default function Logo({ size = 32, title = 'Portail' }) {
  // Deux logos sur une même page partageraient sinon l'identifiant du dégradé.
  // Les deux-points rendus par useId ne passent pas dans une référence url().
  const id = `logo-${useId().replace(/:/g, '')}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label={title}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0F56E3" />
          <stop offset="1" stopColor="#062259" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="115" fill={`url(#${id})`} />
      <rect x="131" y="131" width="108" height="108" rx="26" fill="#019EF7" />
      <rect x="273" y="131" width="108" height="108" rx="26" fill="#A5CE7F" />
      <rect x="131" y="273" width="108" height="108" rx="26" fill="#FCD07E" />
      <rect x="273" y="273" width="108" height="108" rx="26" fill="#E46138" />
    </svg>
  );
}
